import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneLockedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_locked"}/>
}
